import { FlyoutOpenState, FlyoutSide } from '../../Constants';
import lessonManager from '../managers/LessonManager';
import navMenuManager from '../managers/NavMenuManager';

export const RightRailTab = {
  INTERACTIVE: 'interactive',
  FLYOUT: 'flyout'
};

const isPanelOpen = (open) => (
  open === FlyoutOpenState.OPEN ||
  open === FlyoutOpenState.OPEN_WIDE ||
  open === FlyoutOpenState.OPEN_WIDER
);

/**
 * Coordinates the right-edge tab strip on interactive activities (audio, video,
 * and the other viewers that use the questions flyout). The questions panel and
 * the child item's teacher tabs share one column so they stack in the tab strip
 * instead of painting on top of each other.
 */
export class RightRailService {
  hostedFlyoutLessonElementId = null;

  registerHostedFlyout = (lessonElementId) => {
    this.hostedFlyoutLessonElementId = lessonElementId || null;
  }

  isFlyoutPanelShowing = (lessonElementId) => {
    const id = lessonElementId || this.hostedFlyoutLessonElementId;
    if (!id) {
      return false;
    }
    const openState = navMenuManager.getFlyoutOpenState(id);
    if (!openState || openState.side !== FlyoutSide.RIGHT) {
      return false;
    }
    return isPanelOpen(openState.open);
  }

  get selectedTab() {
    if (this.isFlyoutPanelShowing()) {
      return RightRailTab.FLYOUT;
    }
    if (lessonManager.isInteractiveFlyoutOpen) {
      return RightRailTab.INTERACTIVE;
    }
    return null;
  }

  get isOpen() {
    return !!this.selectedTab;
  }

  closeHostedFlyout = () => {
    const lessonElementId = this.hostedFlyoutLessonElementId;
    if (!lessonElementId) {
      return;
    }
    const openState = navMenuManager.getFlyoutOpenState(lessonElementId);
    if (!openState || !isPanelOpen(openState.open)) {
      return;
    }
    navMenuManager.setFlyoutOpenState({
      open: FlyoutOpenState.CLOSED,
      tab: openState.tab,
      side: openState.side
    }, lessonElementId);
  }

  toggleInteractive = () => {
    if (lessonManager.isInteractiveFlyoutOpen && !this.isFlyoutPanelShowing()) {
      lessonManager.setIsInteractiveFlyoutOpen(false);
      return;
    }
    this.closeHostedFlyout();
    lessonManager.setIsInteractiveFlyoutOpen(true);
  }

  /**
   * Open a teacher tab (notes, custom tabs, alignments, rubric, score) in the
   * right rail. Clicking the selected tab closes that panel. Opening one closes
   * the questions panel so only one column is in use.
   */
  toggleFlyoutTab = (innerTab, openState, lessonElementId) => {
    const current = navMenuManager.getFlyoutOpenState(lessonElementId);
    if (!current) {
      return;
    }
    const flyoutIsOpen = isPanelOpen(current.open);
    if (flyoutIsOpen && current.tab === innerTab) {
      navMenuManager.setFlyoutOpenState({
        open: FlyoutOpenState.CLOSED,
        tab: innerTab,
        side: current.side
      }, lessonElementId);
      return;
    }
    lessonManager.setIsInteractiveFlyoutOpen(false);
    navMenuManager.setFlyoutOpenState({
      open: openState,
      tab: innerTab,
      side: current.side
    }, lessonElementId);
  }
}

export default new RightRailService();
